// export const baseUrl = "http://127.0.0.1:8000";
export const baseUrl = "https://api.shahreshimi.ir";
